import { render, staticRenderFns } from "./parentsInformation2.vue?vue&type=template&id=6a1f6c3a&scoped=true&"
import script from "./parentsInformation2.vue?vue&type=script&lang=js&"
export * from "./parentsInformation2.vue?vue&type=script&lang=js&"
import style0 from "./parentsInformation2.vue?vue&type=style&index=0&id=6a1f6c3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f6c3a",
  null
  
)

export default component.exports